module.exports = __webpack_public_path__ + "static/img/banner2.5b677004.png";